import { Card, Title, BarChart } from "@tremor/react";

const CaseStatsCharts = ({ distribution, distributionDepositToPublication, distributionHearingToPublication }) => {
  if (!distribution) return null;

  // Format Κατάθεση → Δικάσιμο distribution
  const distributionDepositToHearing = distribution.map((item) => ({
    Εβδομάδες: item.bucket,
    Υποθέσεις: item.count,
  }));

  // Format Κατάθεση → Δημοσίευση distribution
  const distributionDepositToPub = distributionDepositToPublication?.map((item) => ({
    Εβδομάδες: item.bucket,
    Υποθέσεις: item.count,
  })) || [];

  // Format Δικάσιμο → Δημοσίευση distribution
  const distributionHearingToPub = distributionHearingToPublication?.map((item) => ({
    Εβδομάδες: item.bucket,
    Υποθέσεις: item.count,
  })) || [];

  return (
    <div className="space-y-6">
      {/* Κατάθεση → Δικάσιμο */}
      <Card>
        <Title>Κατάθεση → Δικάσιμο</Title>
        <BarChart
          className="mt-4 h-96"
          data={distributionDepositToHearing}
          index="Εβδομάδες"
          categories={["Υποθέσεις"]}
          colors={["blue"]}
          valueFormatter={(value) => `${value} υποθέσεις`}
          showLegend={false}
          showGridLines={true}
          showAnimation={true}
          showXAxis={true}
          showYAxis={true}
        />
      </Card>

      {/* Κατάθεση → Δημοσίευση */}
      <Card>
        <Title>Κατάθεση → Δημοσίευση</Title>
        <BarChart
          className="mt-4 h-96"
          data={distributionDepositToPub}
          index="Εβδομάδες"
          categories={["Υποθέσεις"]}
          colors={["emerald"]}
          valueFormatter={(value) => `${value} υποθέσεις`}
          showLegend={false}
          showGridLines={true}
          showAnimation={true}
          showXAxis={true}
          showYAxis={true}
        />
      </Card>

      {/* Δικάσιμο → Δημοσίευση */}
      <Card>
        <Title>Δικάσιμο → Δημοσίευση</Title>
        <BarChart
          className="mt-4 h-96"
          data={distributionHearingToPub}
          index="Εβδομάδες"
          categories={["Υποθέσεις"]}
          colors={["amber"]}
          valueFormatter={(value) => `${value} υποθέσεις`}
          showLegend={false}
          showGridLines={true}
          showAnimation={true}
          showXAxis={true}
          showYAxis={true}
        />
      </Card>
    </div>
  );
};

export default CaseStatsCharts;
